import genericStore from "../generic_store";

export default {
    namespaced: genericStore.namespaced,
    state: {
        ...genericStore.state,
        endpoint: "places",
        object: "place",
        header: [
            { text: "Place", value: "place" },
            { text: "Latitude", value: "lat" },
            { text: "Longitude", value: "long" },
            { text: "Acciones", value: "actions", sortable: false }
        ]
    },
    mutations: {
        ...genericStore.mutations
    },
    actions: {
        ...genericStore.actions
    },
    getters: {
        ...genericStore.getters
    }
};
